/**
 * External dependencies
 */
import React, { useState, useRef, useEffect } from 'react';
import { CardComponent, CardNumber, CardExpiry, CardCVV } from '@chargebee/chargebee-js-react-wrapper';
import { connect } from 'react-redux';
import { Box, Stack, Text } from '@towersystems/towersystems-design-system';
import { get, omitBy } from 'lodash';

/**
 * Internal dependencies
 */
import { createPaymentMethodUsingToken } from 'state/payment-methods/actions';

/**
 * Style dependencies
 */
import './styles.scss';

const classes = {
    focus: 'focus-css-class',
    complete: 'complete-css-class',
    invalid: 'invalid-css-class',
    empty: 'empty-css-class',
};

const styles = {};

const AddPaymentMethodForm = ({ afterSubmit, afterReady, afterSuccessSubmit, beforeSubmit, ...props }) => {
    
    const [errors, setErrors] = useState({});
    const [errorMessage, setErrorMessage] = useState('');
    const cardRef = useRef();

    const onSubmit = (e) => {
        if (e) e.preventDefault();
        beforeSubmit && beforeSubmit();
        if (cardRef) {
            // Call tokenize method on card element
            cardRef.current
                .tokenize()
                .then((data) => {
                    // send ajax call to create a subscription or to create a card payment source.
                    props.createPaymentMethodUsingToken(data.token);
                    afterSuccessSubmit && afterSuccessSubmit(data);
                })
                .catch((e) => {
                    console.log('error:', e);
                })
                .finally(() => {
                    afterSubmit && afterSubmit();
                });
        }
    };
    
    // NOTE: the library submits all fields at once
    // each error will override the previous onsubmission if you
    // use callback
    const onChange = (status, a) => {
        setErrors((p) => {
            let newErrors = {
                ...p,
                [status.field]: status.error,
            };
            let filtered = omitBy(newErrors, (a) => {
                return !a || !a.message;
            });
            return filtered;
        });
    };

    const onReady = (el) => {

        el.focus();
        afterReady && afterReady();
    };

    // Using individual fields mode
    return (
        <Box>
            <form onSubmit={onSubmit} id='add-payment-method-form'>
                <div className='fieldset'>
                    <CardComponent className='' ref={cardRef} onReady={onReady}>
                        <Stack space='large'>
                            <Box className='form-floating-label'>
                                <CardNumber
                                    classes={classes}
                                    styles={styles}
                                    placeholder=' '
                                    className='cb-input empty'
                                    onChange={onChange}
                                    onReady={onReady}
                                />
                                <label className='form-floating-label__label form-label'>Card number</label>
                                <Box className='form-floating__ripple' />
                                {errors.number && <Text className='form-error'>Invalid card number.</Text>}
                            </Box>
                            <Box
                                className='stack horizontal'
                                display='flex'
                                flexDirection='row'
                                style={{ width: '100%' }}
                            >
                                <Box className='form-floating-label'>
                                    <CardExpiry placeholder=' ' className='cb-input empty' onChange={onChange} />
                                    <label className='form-floating-label__label form-label'>MM / YY</label>
                                    <Box className='form-floating__ripple' />
                                    {errors.expiry && <Text className='form-error'>Invalid expiry.</Text>}
                                </Box>
                                <Box className='form-floating-label'>
                                    <CardCVV placeholder=' ' className='cb-input empty' onChange={onChange} />
                                    <label className='form-floating-label__label form-label'>CVV</label>
                                    <Box className='form-floating__ripple' />
                                    {errors.cvv && (
                                        <Text className='form-error'>Invalid card verification code (CVC).</Text>
                                    )}
                                </Box>
                            </Box>
                        </Stack>
                    </CardComponent>
                </div>
            </form>
            <Box id='errors'>{errorMessage}</Box>
        </Box>
    );
};

export default connect(null, { createPaymentMethodUsingToken })(AddPaymentMethodForm);
